import { render, staticRenderFns } from "./LoginWithEmailView.vue?vue&type=template&id=54b2729c"
import script from "./LoginWithEmailView.vue?vue&type=script&lang=js"
export * from "./LoginWithEmailView.vue?vue&type=script&lang=js"
import style0 from "./LoginWithEmailView.vue?vue&type=style&index=0&id=54b2729c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports